export default function WarningIcon({
  width,
  height,
}: {
  width?: string | number;
  height?: string | number;
}) {
  return (
    <svg
      width={width||"28"}
      height={height||"28"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.001 19.9999C15.001 20.5522 14.5533 20.9999 14.001 20.9999C13.4487 20.9999 13.001 20.5522 13.001 19.9999C13.001 19.4476 13.4487 18.9999 14.001 18.9999C14.5533 18.9999 15.001 19.4476 15.001 19.9999ZM13.251 16.7499C13.251 17.1641 13.5868 17.4999 14.001 17.4999C14.4152 17.4999 14.751 17.1641 14.751 16.7499V10.2499C14.751 9.8357 14.4152 9.49992 14.001 9.49992C13.5868 9.49992 13.251 9.8357 13.251 10.2499V16.7499ZM11.5935 4.1704C12.639 2.27558 15.3623 2.27514 16.4085 4.16962L25.6589 20.9205C26.6711 22.7534 25.3454 24.9999 23.2516 24.9999H4.75784C2.66449 24.9999 1.33871 22.7541 2.35009 20.9213L11.5935 4.1704ZM15.0954 4.89475C14.6199 4.03362 13.382 4.03382 12.9068 4.8951L3.66341 21.646C3.20369 22.4791 3.80631 23.4999 4.75784 23.4999H23.2516C24.2033 23.4999 24.8059 22.4788 24.3458 21.6456L15.0954 4.89475Z"
        fill='currentColor'
      />
    </svg>
  );
}
